export const hasAudioAds = (state) => state.audioAdsSettings.hasAudioAds
export const applyToRelays = (state) => state.audioAdsSettings.applyToRelays
export const audioAdsAgreement = (state) => state.audioAdsAgreement
